import React, { createContext, useState, useContext, useRef } from 'react';

const ImageContext = createContext();

export const ImageProvider = ({ children }) => {
  const [selectedImage, setSelectedImage] = useState({src : "https://img.icons8.com/?size=100&id=6RfZ-eZQz0ee&format=png&color=737373", alt : "No Product Selected"});
  const [activeTab, setActiveTab] = useState('create');

const imageCanvasRef = useRef(null);  // Base image layer
const drawCanvasRef = useRef(null);   


  return (
    <ImageContext.Provider value={{ selectedImage, setSelectedImage, activeTab, setActiveTab, imageCanvasRef, drawCanvasRef }}>
      {children}
    </ImageContext.Provider>
  );
};

export const useImage = () => {
  const context = useContext(ImageContext);
  if (!context) {
    throw new Error('useImage must be used within an ImageProvider');
  }
  return context;
}; 



